import { FC } from "react";
import style from "../style.module.scss";
import SectionMultiCheckbox from "../sections/sectionMultiCheckbox";
import SectionRadio from "../sections/sectionRadio";
import SectionRadioWithValue from "../sections/sectionRadioWithValue";
import ColorIndicatorComponent from "../sections/colorIndicator";

const MemberDetailsTab: FC<any> = ({
  config,
  onChange
}) => {
  const onComponentChange = (index: number, pref: any) => {
    let updated = [...config];
    updated[index].config_optn_val = pref;
    onChange(updated);
  }
  return (
    <div className={style.cm_tab}>
      {config && config.map((conf:any, index: number)=>{

        console.log("Config in Member details", config)

        if(conf.config_optn_type === 'multi_check_box'){
          return(<SectionMultiCheckbox config={conf} key={index} onChange={(pref: any)=>onComponentChange(index, pref)} />)
        }
        if(conf.config_optn_type === 'radio'){
          return(<SectionRadio config={conf} key={index} onChange={(pref: any)=>onComponentChange(index, pref)} />)
        }
        if(conf.config_optn_type === 'radio_value'){
          return(<SectionRadioWithValue config={conf} key={index} onChange={(pref: any)=>onComponentChange(index, pref)} />)
        }

        if(conf.config_optn_type === 'color_indicators'){
          return(<ColorIndicatorComponent config={conf} key={index} onChange={(pref: any)=>onComponentChange(index, pref)} />)
        }
        return <></>
      })}      
    </div>
  );
};

export default MemberDetailsTab;
